export default __webpack_public_path__ + "static/media/ic_thumb_up_24px.8ba7aa19.svg";